import { render } from "./DashboardLeave.vue?vue&type=template&id=27cb2a0f"
import script from "./DashboardLeave.vue?vue&type=script&lang=js"
export * from "./DashboardLeave.vue?vue&type=script&lang=js"

import "./DashboardLeave.vue?vue&type=style&index=0&id=27cb2a0f&lang=css"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__